import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_left",
  "use": "arrow_left-usage",
  "viewBox": "0 0 15.969 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 15.969 11\" id=\"arrow_left\"><path d=\"M5.216 10.806c.217.22.579.22.805 0a.547.547 0 0 0 0-.779L1.94 6.039h13.466a.556.556 0 0 0 .563-.552.56.56 0 0 0-.563-.558H1.94L6.021.948a.557.557 0 0 0 0-.787.573.573 0 0 0-.805 0L.169 5.094a.534.534 0 0 0 0 .779l5.047 4.933Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol